/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PaginationModel from './PaginationModel';
import PermissionDetailsDto from './PermissionDetailsDto';

/**
 * The SearchingQueryResponseMapModelstringListPermissionDetailsDto model module.
 * @module model/SearchingQueryResponseMapModelstringListPermissionDetailsDto
 * @version v1.0.0
 */
class SearchingQueryResponseMapModelstringListPermissionDetailsDto {
    /**
     * Constructs a new <code>SearchingQueryResponseMapModelstringListPermissionDetailsDto</code>.
     * @alias module:model/SearchingQueryResponseMapModelstringListPermissionDetailsDto
     */
    constructor() { 
        
        SearchingQueryResponseMapModelstringListPermissionDetailsDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseMapModelstringListPermissionDetailsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseMapModelstringListPermissionDetailsDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseMapModelstringListPermissionDetailsDto} The populated <code>SearchingQueryResponseMapModelstringListPermissionDetailsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseMapModelstringListPermissionDetailsDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], {'String': [PermissionDetailsDto]});
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseMapModelstringListPermissionDetailsDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Object.<String, Array.<module:model/PermissionDetailsDto>>} result
 */
SearchingQueryResponseMapModelstringListPermissionDetailsDto.prototype['result'] = undefined;






export default SearchingQueryResponseMapModelstringListPermissionDetailsDto;

